export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Fire Service Instructor Atlas after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is successfully completed.'],
  },
  {
    q: 'Do I need to be an experienced fire service instructor?',
    a: [
      'The system is designed to support instructors at different experience levels. Practical firefighter training must always be delivered by appropriately qualified personnel under applicable procedures.',
    ],
  },
  {
    q: 'Is this system suitable for fire academies?',
    a: [
      'Yes. The material is designed as supplementary instructional and reference material for professional firefighter education, subject to approval and local training requirements.',
    ],
  },
  {
    q: 'Is it really a 100% visual system?',
    a: [
      'Yes. The six main volumes use a visual teaching approach featuring diagrams, illustrations, maps, comparisons, scenarios and instructor reference sheets. The five additional bonuses provide complementary written resources.',
    ],
  },
  {
    q: 'Does it include ready-to-use training material?',
    a: [
      'Yes. The system includes teaching references, classroom scenarios, instructor prompts, assessment tools and training frameworks.',
    ],
  },
  {
    q: 'Does it cover beginner and advanced subjects?',
    a: [
      'Yes. The material spans foundational firefighter education, operational awareness, specialized incident references and instructor development. It does not replace required certification or specialist training.',
    ],
  },
  {
    q: 'Can active firefighters use it for reference?',
    a: [
      'Yes. Although created primarily for instructors, the atlas can also be used as a supplementary learning and review resource.',
    ],
  },
  {
    q: 'Does it include all six volumes?',
    a: ['Yes. The complete 6-in-1 package includes the six listed professional volumes.'],
  },
  {
    q: 'Are the five bonuses included?',
    a: ['Yes. All five professional instructor bonuses are included with the complete package.'],
  },
  {
    q: 'Does it include videos?',
    a: ['No. The material is delivered in digital PDF format.'],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes. The material is written in English for an international audience.'],
  },
  {
    q: 'Can I edit the files?',
    a: ['The materials are provided in PDF format, not as editable source files.'],
  },
  {
    q: 'Does this replace official firefighter training standards or department SOPs?',
    a: [
      'No. Fire Service Instructor Atlas is a supplementary training and reference resource. Applicable professional standards, department procedures and qualified instructor supervision remain essential.',
    ],
  },
  {
    q: 'Is this a one-time purchase?',
    a: ['Yes. The advertised package is available through a one-time payment.'],
  },
]
